import { getLocaleCode } from './getCountryCode';
let frameworks;
export const getPrivacyFramework = async () => {
    if (typeof frameworks === 'undefined') {
        const isInUS = (await getLocaleCode()) === 'US';
        frameworks = {
            ccpa: isInUS,
            tcfv2: !isInUS,
        };
    }
    return frameworks;
};
